import Vue from 'vue'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import { phoneMask } from '../masks.js'
import toastr from '../toastr'
import Multiselect from '@component/dccore-form/multiselect.vue'
import Inputmask from 'inputmask'
import TextInput from '@component/dccore-form/textInput.vue'
import Singleselect from '@component/dccore-form/singleselect.vue'
import { EMPLOYEE_DEFAULT_TYPE } from '@const/user'

if ($('#employee_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#employee_form',
    components: {
      RingLoader,
      Multiselect,
      TextInput,
      Singleselect,
    },
    mixins: [mixins],
    data: {
      loading: 0,
      user: {
        phone: '+48 ',
        plainPassword: {
          first: null,
          second: null,
        },
        userRoles: [],
      },
      errors: {
        plainPassword: {
          first: null,
          second: null,
        }
      },
      roles: [],
      clientTypes: [],
      userId: null,
      defaultEmployeeType: null,
    },
    watch: {
      'user.email': function(newEmail) {
        let upperNewValue = newEmail.toLowerCase()
        if (upperNewValue !== newEmail) {
          this.user.email = upperNewValue
        }
      }
    },
    mounted: function () {
      let im = Inputmask(phoneMask)
      im.mask($('#form_phone')[0])

      this.loading++
      this.getRoles()
      this.getClientTypes()
      if ($('#entity_id').length) {
        this.userId = $('#entity_id').val()
        this.getUser()
      }

      this.loading--
    },
    methods: {
      createEmployee: function (redirect) {
        let url = Routing.generate('api_post_employee')

        let data = { data: this.user }
        this.loading++

        this.$http.post(url, data).then(() => {
          this.errors = {
            plainPassword: {
              first: null,
              second: null,
            }
          }
          if (redirect) {
            $(location).attr('href', Routing.generate('employee_grid'))
          } else {
            toastr.success(Translator.trans('form.created'))
          }
          this.loading--

        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      updateEmployee: function (redirect) {
        this.loading++

        let url = Routing.generate('api_patch_employee', {
          id: this.userId,
        })

        let data = { data: this.user }

        this.$http.patch(url, data).then(() => {
          this.errors = {
            plainPassword: {
              first: null,
              second: null,
            }
          }
          if (redirect) {
            $(location).attr('href', Routing.generate('employee_grid'))
          } else {
            toastr.success(Translator.trans('form.updated'))
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getUser: function () {
        this.loading++
        let url = Routing.generate('api_get_employee', { id: this.userId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          let data = response.data
          data.plainPassword = {
            first: null,
            second: null,
          }

          this.user = data

          if (!this.user.phone) {
            this.user.phone = '+48 '
          }

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getRoles() {
        this.loading++
        let url = Routing.generate('api_get_roles_employee', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.roles = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getClientTypes() {
        this.loading++
        const url = Routing.generate('api_get_tags', { 'type': 'client_type',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.clientTypes = response.data
          this.loading--
          if (!this.userId) {
            this.defaultEmployeeType = this.getDefaultEmployeeTypeId()
          }
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getDefaultEmployeeTypeId() {
        let clientType = this.clientTypes.find((item) => {
          return item.systemValue === EMPLOYEE_DEFAULT_TYPE
        })
        return clientType.id
      },
    }
  })
}
